
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.782 16.833l-3.115-3.115a.75.75 0 00-.532-.219h-.51a6.467 6.467 0 001.376-4c0-3.59-2.91-6.499-6.5-6.499a6.499 6.499 0 100 12.999 6.47 6.47 0 004-1.375v.51c0 .2.078.39.219.53l3.115 3.116a.747.747 0 001.06 0l.884-.885a.753.753 0 00.003-1.062zM9.5 13.499c-2.21 0-4-1.787-4-4 0-2.209 1.788-4 4-4 2.21 0 4 1.788 4 4 0 2.21-1.787 4-4 4z","fill":"#282498","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_search.svg